const isEmptyObject = (obj: { [key: string]: any } | null | undefined): boolean => {
  if (!obj) {
    return false;
  }

  // Checking if the top-level object is empty
  for (const key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      const value = obj[key];

      // If the value is an object, check if it is empty recursively
      if (typeof value === 'object' && value !== null) {
        for (const k in value) {
          if (Object.prototype.hasOwnProperty.call(value, k) && value[k] !== null) {
            return false;
          }
        }
      } else if (value !== null) {
        return false;
      }
    }
  }
  return true;
};

export default isEmptyObject;
